import { Component } from '@angular/core';

@Component({
  selector: 'mm-under-construction',
  templateUrl: './under-construction.component.html',
})
export class UnderConstructionComponent {

}
